export {useAuthedMonolithQuery} from "./useAuthedMonolithQuery";
